<template>
  <div class="app">
    <CHeader />

    <router-view />
  </div>
</template>

<script setup>
  import { onMounted, onUnmounted } from 'vue';

  import CHeader from '@/components/CHeader/CHeader.vue';

  import { useVendingMachinesList } from '@/composables/useVendingMachinesList';
  import { useBodyScroll } from '@/composables/useBodyScroll';

  const {
    registerScrollHandler: registerBodyScrollHandler,
    unregisterScrollHandler: unregisterBodyScrollHandler
  } = useBodyScroll();
  useBodyScroll();

  const { loadVendingMachines } = useVendingMachinesList();

  loadVendingMachines();

  onMounted(() => {
    registerBodyScrollHandler();
  });

  onUnmounted(() => {
    unregisterBodyScrollHandler();
  });
</script>

<style>
  @import './assets/styles/index.css';
  @import '@/assets/styles/index.css';

  #app {
    font-family: 'Montserrat', Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
  }

  .app {
    padding: 120px 54px 24px;
    /* max-width: 1200px; */
    margin: 0 auto;
  }

  nav {
    padding: 30px;

    a {
      font-weight: bold;
      color: #2c3e50;

      &.router-link-exact-active {
        color: #42b983;
      }
    }
  }

  .grecaptcha-badge {
    visibility: hidden !important;
  }

  @media (--mobile) {
    .app {
      padding: 100px 22px 24px;
    }
  }
</style>
